<template>
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="活动主题">
                    <el-input v-model="search.title" placeholder="请输入活动主题"></el-input>
                </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='Add'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" border style="width: 100%" ref="table" class="custom-tbl">
                <el-table-column type="index" width="80" label="序号"></el-table-column>
                <el-table-column prop="Title" label="活动主题" width="200"></el-table-column>
                <el-table-column prop="Content" label="活动内容" show-overflow-tooltip></el-table-column>
                <el-table-column prop="MiniQRCodeUrl" label="小程序码" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.MiniQRCodeUrl!=null">
                            <el-popover placement="left" trigger="click" style="width:400px;cursor:pointer;">
                                <img :src="scope.row.MiniQRCodeUrl" width="100%" />
                                <img slot="reference" :src="scope.row.MiniQRCodeUrl" :alt="scope.row.MiniQRCodeUrl" width="60" height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="EndDateString" label="活动截止日期" width="160"></el-table-column>
                <!-- <el-table-column prop="BrandType" label="品牌" width="120"></el-table-column> -->
                <el-table-column prop="CreateBy" label="创建用户" width="120"></el-table-column>
                <el-table-column prop="CreateTimeString" label="创建时间" width="160"></el-table-column>
                <el-table-column prop="Enabled" label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled==true ? 'success' : 'danger'" disable-transitions>{{
                            scope.row.Enabled==true ? "启用" : "停用" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" fixed="right">
                    <template scope="scope">
                        <el-button size="small" type="primary"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('update') != -1).length > 0"
                            @click="update(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('handledel') != -1).length > 0"
                            @click="handledel(scope.row)">删除</el-button>
                        <el-button type="warning" size="small" style="margin-top: 5px;"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('RegenerateQRCode') != -1).length > 0"
                            @click="RegenerateQRCode(scope.row)">重新生成小程序码</el-button>
                        <el-button type="info" size="small" style="margin-top: 5px;"
                            @click="viewRegistrations(scope.row)">查看报名</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>

        <!--修改界面-->
        <el-dialog title="活动配置" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
                <el-form-item label="活动主题" prop="Title">
                    <el-input v-model="editForm.Title" placeholder="请输入活动主题"></el-input>
                </el-form-item>
                <el-form-item label="活动内容" prop="Content">
                    <el-input v-model="editForm.Content" type="textarea" :rows="3" placeholder="请输入活动内容"></el-input>
                </el-form-item>
                <el-form-item label="活动截止日期" prop="EndDate">
                    <el-date-picker v-model="editForm.EndDate" type="datetime" placeholder="选择活动截止日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="品牌标识" prop="BrandType">
                    <selectPBBrand style="width: 100%" v-model="editForm.BrandType">
                    </selectPBBrand>
                </el-form-item>
                <el-form-item label="状态" prop="Enabled">
                    <el-radio-group v-model="editForm.Enabled">
                        <el-radio :label="true">启用</el-radio>
                        <el-radio :label="false">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
        <!--报名名单弹窗-->
        <el-dialog :title="registrationTitle" :visible.sync="registrationVisible" width="900px" :close-on-click-modal="false">
            <el-form :inline="true" :model="registrationSearch" style="padding-bottom: 10px;">
                <el-form-item label="关键词">
                    <el-input v-model="registrationSearch.keyword" placeholder="姓名/电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="registrationQuery">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="registrationData" v-loading="registrationLoading" border style="width: 100%" max-height="500">
                <el-table-column type="index" width="70" label="序号"></el-table-column>
                <el-table-column prop="Name" label="姓名" width="120"></el-table-column>
                <el-table-column prop="Phone" label="电话" width="140"></el-table-column>
                <el-table-column prop="InvitationCode" label="邀请码" width="120"></el-table-column>
                <el-table-column prop="ActivityTitle" label="活动主题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="RegistrationTimeString" label="报名时间" width="170"></el-table-column>
                <el-table-column prop="StatusString" label="状态" width="80"></el-table-column>
            </el-table>
            <el-pagination layout="total, sizes, prev, pager, next" @current-change="registrationCurrentChange"
                @size-change="registrationSizeChange" :current-page.sync="registrationPage"
                :page-size="registrationPageSize" :total="registrationTotal" style="float: right; margin-top: 10px;"></el-pagination>
            <div style="clear: both;"></div>
        </el-dialog>
    </section>
</template>

<script>
    import {getButtonList} from "../../../promissionRouter";
    import {getActivityManagePageList,removeActivityManage,PostActivityManage,RegenerateActivityQRCode,getActivityRegistrationPageList} from '../../../api/api';

    export default {
        data() {
            return {
                buttonList:[],
                search: { title: "" },
                total: 0,
                page: 1,
                intPageSize:30,
                listLoading: false,
                data:[],

                //修改
                editFormVisible:false,
                editLoading:false,
                editForm:{
                    Id: 0,
                    Title:'',
                    Content:'',
                    EndDate:'',
                    BrandType:'',
                    Enabled:true
                },
                editFormRules: {
                    Title: [{ required: true, message: "请输入活动主题", trigger: "blur" }],
                    EndDate: [{ required: true, message: "请选择活动截止日期", trigger: "change" }],
                    BrandType:[{ required: true, message: "请选择品牌", trigger: "change" }]
                },
                IsAdd:true,

                //报名名单弹窗
                registrationVisible:false,
                registrationLoading:false,
                registrationTitle:'',
                registrationSearch:{ keyword:'' },
                registrationData:[],
                registrationTotal:0,
                registrationPage:1,
                registrationPageSize:10,
                currentActivityId:0
            }
        },
        methods: {
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },
            getActivityManagePageList() {
                 this.listLoading=true;
                let para = {
                    title: this.search.title,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getActivityManagePageList(para).then((res) => {
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getActivityManagePageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getActivityManagePageList();
            },
            //查询
            query()
            {
               this.page = 1;
               this.getActivityManagePageList();
            },
            //删除
            handledel(row)
            {
                 this.$confirm("确认删除该活动吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    this.listLoading = true;
                    removeActivityManage(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getActivityManagePageList();
                        } else {
                        this.$message({
                            message: "删除失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //新增
            Add()
            {
                this.editForm = {
                    Id: 0,
                    Title:'',
                    Content:'',
                    EndDate:'',
                    BrandType:'',
                    Enabled:true
                };
                this.IsAdd = true;
                this.editFormVisible=true;
            },
            //编辑
            update(row){
                this.editForm = Object.assign({}, row);
                this.IsAdd = false;
                this.editFormVisible=true;
            },
            editSubmit(){
                this.$refs.editForm.validate((valid)=>{
                    if(valid)
                    {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            PostActivityManage(para).then((res)=>{
                                this.editLoading = false;
                                if(res.data.success)
                                {
                                    this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                    });
                                    this.editFormVisible=false;
                                    this.getActivityManagePageList();
                                }else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            })
                        });
                    }else{
                        return true;
                    }
                })
            },
            //重新生成小程序码
            RegenerateQRCode(row)
            {
                 this.$confirm("确认重新生成该活动的小程序码吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    this.listLoading = true;
                    RegenerateActivityQRCode(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: "生成成功!",
                            type: "success",
                        });
                        this.getActivityManagePageList();
                        } else {
                        this.$message({
                            message: res.data.msg || "生成失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //打开报名名单弹窗
            viewRegistrations(row){
                this.currentActivityId = row.Id;
                this.registrationTitle = `【${row.Title}】报名名单`;
                this.registrationSearch = { keyword:'' };
                this.registrationPage = 1;
                this.registrationPageSize = 10;
                this.registrationVisible = true;
                this.getRegistrationList();
            },
            //查询报名名单
            getRegistrationList(){
                this.registrationLoading = true;
                let para = {
                    activityId: this.currentActivityId,
                    keyword: this.registrationSearch.keyword,
                    page: this.registrationPage,
                    intPageSize: this.registrationPageSize
                };
                getActivityRegistrationPageList(para).then((res) => {
                    this.registrationLoading = false;
                    if(res.data.success){
                        this.registrationTotal = res.data.response.dataCount;
                        this.registrationData = res.data.response.data || [];
                    }else{
                        this.$message({ message: res.data.msg || "查询失败", type: "error" });
                    }
                }).catch(() => {
                    this.registrationLoading = false;
                });
            },
            registrationQuery(){
                this.registrationPage = 1;
                this.getRegistrationList();
            },
            registrationCurrentChange(val){
                this.registrationPage = val;
                this.getRegistrationList();
            },
            registrationSizeChange(val){
                this.registrationPageSize = val;
                this.getRegistrationList();
            }
        },
        mounted() {
              let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.getActivityManagePageList();
        }
    }
</script>

<style>
    .toolbar {
        padding: 10px;
    }
</style>
